import { handleActions } from 'redux-actions';
import { types } from './bigpoints.meta';

const initialState = {
  applyBigpoints: true,
};

export function toggleBigpoint(state, { payload }) {
  return {
    ...state,
    ...payload,
  };
}

export default handleActions(
  {
    [types.BIG_POINTS_TOGGLE]: toggleBigpoint,
  },
  initialState
);
